import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useRouter } from '@cvt/routing';

export const useWizard = () => {
  const { pathname } = useLocation();
  const router = useRouter();

  const stepRoutes = useMemo(() => ([
    { step: 'details', pattern: router.tributes.create.details.path },
    { step: 'media', pattern: router.tributes.create.media.path },
    { step: 'story', pattern: router.tributes.create.story.path },
    { step: 'order', pattern: router.tributes.create.order().path }, // contains :tributeId
  ]), [router]);

  const activeStepIndex = useMemo(() => {
    const idx = stepRoutes.findIndex(({ pattern }) =>
      Boolean(matchPath({ path: pattern, end: false }, pathname)),
    );
    return idx === -1 ? 0 : idx;
  }, [pathname, stepRoutes]);

  return {
    currentStepNumber: activeStepIndex + 1,
    activeStepIndex,
  };
};